var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaskGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "579px",
    height: "507px",
    transform: "rotate(0) scale(1, 1)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C191.07 0 382.14 0 579 0 C579 167.31 579 334.62 579 507 C387.93 507 196.86 507 0 507 C0 339.69 0 172.38 0 0 Z ",
    fill: "#fefefe",
    transform: "translate(0,0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C60.39 0 120.78 0 183 0 C183 31.35 183 62.7 183 95 C122.61 95 62.22 95 0 95 C0 63.65 0 32.3 0 0 Z ",
    fill: "#929395",
    transform: "translate(97,288)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C60.06 0 120.12 0 182 0 C182 31.35 182 62.7 182 95 C121.94 95 61.88 95 0 95 C0 63.65 0 32.3 0 0 Z ",
    fill: "#f2f4f7",
    transform: "translate(306,237)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C60.06 0 120.12 0 182 0 C182 31.02 182 62.04 182 94 C121.94 94 61.88 94 0 94 C0 62.98 0 31.96 0 0 Z ",
    fill: "#f2f4f7",
    transform: "translate(306,88)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C60.39 0 120.78 0 183 0 C183 30.69 183 61.38 183 93 C122.61 93 62.22 93 0 93 C0 62.31 0 31.62 0 0 Z ",
    fill: "#929395",
    transform: "translate(97,123)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C60.39 0 120.78 0 183 0 C183 31.35 183 62.7 183 95 C122.61 95 62.22 95 0 95 C0 63.65 0 32.3 0 0 Z M1 2 C1 32.36 1 62.72 1 94 C60.4 94 119.8 94 181 94 C181 63.64 181 33.28 181 2 C121.6 2 62.2 2 1 2 Z ",
    fill: "#929395",
    transform: "translate(97,288)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C60.39 0 120.78 0 183 0 C183 30.69 183 61.38 183 93 C122.61 93 62.22 93 0 93 C0 62.31 0 31.62 0 0 Z M1 2 C1 31.7 1 61.4 1 92 C60.4 92 119.8 92 181 92 C181 62.3 181 32.6 181 2 C121.6 2 62.2 2 1 2 Z ",
    fill: "#929395",
    transform: "translate(97,123)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C60.06 0 120.12 0 182 0 C182 31.02 182 62.04 182 94 C121.94 94 61.88 94 0 94 C0 93.34 0 92.68 0 92 C59.4 92 118.8 92 180 92 C180 61.97 180 31.94 180 1 C120.93 1 61.86 1 1 1 C1 18.82 1 36.64 1 55 C0.67 55 0.34 55 0 55 C0 36.85 0 18.7 0 0 Z ",
    fill: "#f2f4f7",
    transform: "translate(306,88)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskGrey);
export default __webpack_public_path__ + "static/media/task_grey.405bfd6a743ebdef2a5faf7186e64b29.svg";
export { ForwardRef as ReactComponent };